<template>
  <div class="filter">
    <div class="filter-item">
      <input type="text" v-model="input" @input="onFilterInput" :placeholder="language.search">
    </div>
    <div class="filter-item">
      <select v-model="filterCity" @change="onSelected">
        <option value="0">{{language.choose_city}}</option>
        <option v-for="label in labels" :value="label">{{ label }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Filter',
  props: {
    labels: Array,
    language: Object
  },
  data() {
    return {
      filterCity: 0,
      input: '',
    }
  },
  methods: {
    onSelected: function () {
      this.emitter.emit('onSelectedFilter', {
        filterCity: this.filterCity
      });
    },
    onFilterInput: function() {
      this.emitter.emit('onFilterInput', {
        input: this.input
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: flex-start;
}

.filter-item {
  input, select {
    padding: 3px 10px;
    outline: none;
    font-size: 16px;
    margin-right: 10px;
  }
}

@media (max-width: 800px) {
  .filter {
    flex-direction: column;
    input {
      display: block;
      margin-bottom: 10px;
      width: 100%;
      padding-right: 0;
      box-sizing: border-box;
      margin-right: 0;
    }

    select {
      width: 100%;
      margin-right: 0;
    }
  }
}
</style>